import { render, staticRenderFns } from "./huaxiang.vue?vue&type=template&id=60c86c10&scoped=true&"
import script from "./huaxiang.vue?vue&type=script&lang=ts&"
export * from "./huaxiang.vue?vue&type=script&lang=ts&"
import style0 from "./huaxiang.vue?vue&type=style&index=0&id=60c86c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c86c10",
  null
  
)

export default component.exports